import React from 'react';

const IntroPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/intro',
			exact: true,
			component: React.lazy(() => import('./IntroPage')),
		},
	],
};

export default IntroPageConfig;
